import {hasProperty} from '@helpers/HelperFunc'

export default class PriceVO {
	id = ''
	serviceName = ''
	serviceId = ''
	priceNew = ''
	priceNewAdditional = ''
	priceNewFormatted = ''
	basePriceNew = ''
	basePriceNewAdditional = ''
	priceRenew = ''
	priceRenewAdditional = ''
	priceRenewFormatted = ''
	basePriceRenew = ''
	basePriceRenewAdditional = ''
	monthlyPriceNew = ''
	monthlyPriceNewAdditional = ''
	monthlyBasePriceNew = ''
	monthlyBasePriceNewAdditional = ''
	term = ''
	termEn = ''
	currency = ''
	currencyAdditional = ''
	discount = 0
	discount_sum = 0
	isPremium = 0
	termClear = 1;

	constructor(params) {
		for (const property in this) {
			if (hasProperty(this, property) && hasProperty(params, property)) {
				this[property] = params[property]
			}
		}

		this.priceNew = parseFloat(this.priceNew).toFixed(2)
		this.priceNewAdditional = parseFloat(this.priceNewAdditional).toFixed(2)
		this.basePriceNew = parseFloat(this.basePriceNew).toFixed(2)
		this.basePriceNewAdditional = parseFloat(this.basePriceNewAdditional).toFixed(2)
		this.priceRenew = parseFloat(this.priceRenew).toFixed(2)
		this.priceRenewAdditional = parseFloat(this.priceRenewAdditional).toFixed(2)
		this.basePriceRenew = parseFloat(this.basePriceRenew).toFixed(2)
		this.basePriceRenewAdditional = parseFloat(this.basePriceRenewAdditional).toFixed(2)
		this.monthlyPriceNew = parseFloat(this.monthlyPriceNew).toFixed(2)
		this.monthlyPriceNewAdditional = parseFloat(this.monthlyPriceNewAdditional).toFixed(2)
		this.monthlyBasePriceNew = parseFloat(this.monthlyBasePriceNew).toFixed(2)
		this.monthlyBasePriceNewAdditional = parseFloat(this.monthlyBasePriceNewAdditional).toFixed(2)
		this.discount = parseInt(this.discount)
		this.discount_sum = parseInt(this.discount_sum)
		this.termClear = parseInt(this.termClear);
	}
}
